import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display an image with the specified URL and alt text and figure caption.
 */
@Component({
  selector: 'app-custom-page-image',
  template: `<div
    class="mx-auto"
    [ngClass]="{
      'max-w-[60%]': data().size === 'small',
      'max-w-screen-lg': data().size === 'standard',
      'max-w-screen-xl': data().size === 'wide',
      'px-8': data().size !== 'full_width',
    }"
  >
    <figure>
      <img [src]="data().url" [alt]="data().alt" [class.w-full]="data().size === 'full_width'" class="mb-2 mx-auto" />
      <figcaption class="text-center italic">{{ data().caption }}</figcaption>
    </figure>
  </div>`,
  imports: [CommonModule],
  standalone: true,
})
export class CustomPageImageComponent extends CustomPageBlockComponent<'image'> {}
